export const KPICopy = {
  listTitle: "Key Performance Indicators",
  listIntro: "Monitor performance signals across critical workflows, controls, and operating commitments.",
  listIntroSecondary:
    "Use KPIs to review trends, thresholds, measurement cadence, and linked operational context in one workspace.",
  betaNotice:
    "KPIs provide performance visibility across your governance program and help teams track changing operational signals over time.",
  notAvailable:
    "Some delivery channels and broader reporting views may depend on environment configuration.",
  listEmptyTitle: "No KPIs yet",
  listEmptyBody:
    "No KPIs yet. Create a KPI to start tracking performance and trends across your GRC program.",
  listEmptyCreateHint: "Admins and managers can create KPIs.",
  listEmptyCta: "Create KPI",
  overviewHelper:
    "A KPI measures performance over time. Values are compared against targets to show whether things are improving or deteriorating.",
  overviewEvalHint:
    "Status uses red, amber, and green based on thresholds. KPIs become stale when updates are overdue.",
  measurementsHelper:
    "Measurements are point-in-time values collected manually, imported, or calculated.",
  linksHelper:
    "Link KPIs to risks, controls, incidents, audits, or vendors to understand what this KPI measures or impacts.",
  settingsFrequency: "How often this KPI is expected to be updated.",
  settingsApproval: "When enabled, measurements must be approved before affecting KPI status.",
  settingsThresholds:
    "Thresholds define when performance is considered healthy, at risk, or critical.",
  alertsPlaceholder:
    "Alert rules are managed from the Alerts tab for this KPI.",
  readOnlyNotice:
    "Read-only access. You can view KPI details but cannot make changes.",
  archivedNotice: "This KPI is archived and read-only.",
  relatedSubtitle:
    "KPIs linked to this record show related performance trends and early warning indicators.",
  relatedCaption:
    "KPIs appear here to show performance trends related to this item. They are informational in Phase 1.",
  dashboardTitle: "KPI Dashboards",
  dashboardBanner:
    "Dashboards group KPI signals into focused monitoring views for leadership and operational follow-up.",
};
